import { render, staticRenderFns } from "./FinaliseStep.vue?vue&type=template&id=4f4f1086&scoped=true"
import script from "./FinaliseStep.vue?vue&type=script&lang=js"
export * from "./FinaliseStep.vue?vue&type=script&lang=js"
import style0 from "./FinaliseStep.vue?vue&type=style&index=0&id=4f4f1086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4f1086",
  null
  
)

export default component.exports